import t, { forwardRef as v, useState as S } from "react";
import { SelectionItemsDefaultProps as g } from "../props.js";
const p = v((d, u) => {
  const {
      selectionItems: n = g.selectionItems,
      onSelectedChange: a,
      defaultSelectedItemIndex: s
    } = d,
    [c, o] = S(s !== void 0 ? s : null),
    r = e => {
      e === c ? (o(null), a == null || a([])) : (o(e), a == null || a([n[e].value]));
    };
  return t.createElement("ul", {
    className: "olx-chips__items"
  }, n == null ? void 0 : n.map((e, l) => {
    var m;
    const {
        value: i,
        icon: h,
        isDisabled: _
      } = e,
      f = (m = e.label) != null ? m : e.value;
    return t.createElement("li", {
      className: "olx-chips__item",
      key: i
    }, t.createElement("div", {
      className: "olx-chips__input-wrapper",
      ref: u
    }, t.createElement("input", {
      "data-ds-component": "DS-Chips",
      "data-testid": "single-chips-input-".concat(l),
      type: "radio",
      className: "olx-chips__input",
      id: "single-chips-id-".concat(l),
      name: i,
      checked: l === c,
      disabled: _,
      onChange: () => r(l)
    }), t.createElement("label", {
      htmlFor: "single-chips-id-".concat(l),
      className: (i == null ? void 0 : i.length) === 1 ? "olx-chips__input--one-value" : ""
    }, h, f)));
  }));
});
p.displayName = "SingleSelect";
export { p as SingleSelect };